import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import ChooseUs from "../components/ChooseUs";
import Banner from "../components/Banner";
import Pricing from "../components/Pricing";
import Footer from "../components/Footer";
import { useRef } from "react";
function Homepage() {
  const heroRef = useRef(null);
  return (
    <>
    
    <div className="w-full h-14 bg-[#2db928] overflow-hidden whitespace-nowrap  flex justify-center content-center py-auto items-center">
      {" "}
      {/* Add margin-top here */}
      <p className='inline-block animate-scroll after:content-["  "] leading-3 delay-1000 text-gray-100 items-center '>
        Investment/Trading in Securities Market is subject to market risk. Read
        all the related documents carefully before investing. Please read the
        document of our privacy policy,terms of use & disclaimer on our
        website. We do not provide any guaranteed or assured return services,
        profit sharing services, Demat Account services, Investment related
        services or any other services which are not mentioned on our website.
      </p>
    </div>
    {/* <div className="flex justify-center items-center relative">
  <div className="w-full flex justify-between fixed top-1/2 transform -translate-y-1/2 z-50">
    
    <div className="bg-blue-500 flex items-center py-4 px-2  rounded-e-2xl">
      <p className="text-white rotate-180 text-lg font-bold" style={{ writingMode: "vertical-lr" }}>
        user content
      </p>
    </div>

 
    <div className="bg-red-600 py-4 px-2  rounded-s-2xl">
      <p className="text-white rotate-180 text-lg font-bold" style={{ writingMode: "vertical-lr" }}>component board</p>
    </div>
  </div>
</div> */}

      <div ref={heroRef}>
        <Hero />
      </div>
      <About />
      <Pricing heroRef={heroRef} />
      <ChooseUs />
      <Banner heroRef={heroRef} />
      <Footer />
    
    </>
  );
}

export default Homepage;
